import i18next from "i18next";
import { inicializarInternacionalizacao } from "./localizacao/vagas/vagas";
import { autocompleteBuscaRecenteCargo, autocompleteBuscaRecenteLocalizacao } from './utilidades/eventoBuscarVagaRedirect';
import { convertDatetimeStringToTimezone } from "./utilidades/convertDatetimeStringToTimezone";
import { getGeoData } from "./utilidades/geoData";
import { obterQueryString } from "./utilidades/obterQueryString";

inicializarInternacionalizacao();

const editais = {
  props: {
    estadoAbas: {
      'abertos': { pagina: 1, totalPaginas: 1, statusFiltro: 'Aberta', container: document.querySelector('#abertos .listagem-vagas') },
      'andamento': { pagina: 1, totalPaginas: 1, statusFiltro: 'Fechada', container: document.querySelector('#andamento .listagem-vagas') },
      'encerrados': { pagina: 1, totalPaginas: 1, statusFiltro: 'Encerrada', container: document.querySelector('#encerrados .listagem-vagas') },
      'congelados': { pagina: 1, totalPaginas: 1, statusFiltro: 'Congelada', container: document.querySelector('#congelados .listagem-vagas') },
      'cancelados': { pagina: 1, totalPaginas: 1, statusFiltro: 'Cancelada', container: document.querySelector('#cancelados .listagem-vagas') }
    },
    abaAtiva: 'abertos',
    carregando: false,
    elementos: {
      btnCarregarContainer: document.querySelector('.box-carregar-mais-vagas'),
      btnCarregar: document.querySelector('.btn-carregar-mais-vagas'),
      contadorMobileContainer: document.querySelector('.navbar-filtros .quantidade-total-vagas'),
      regiaoStatus: document.getElementById('status-busca-editais')
    },
    observerCarregarMaisVagas: null,
    filtrosSelecionados: [],
  },
  statusMap: {
    'abertos': 'aberta',
    'andamento': 'fechada',
    'encerrados': 'encerrada',
    'congelados': 'congelada',
    'cancelados': 'cancelada'
  },
  templates: {
    textoIndicadorPagina(pagina, totalPaginas) {
      return `<p class="my-4 mx-3 mx-md-0">${i18next.t('TemplateTextoIndicadorPagina', { pagina: pagina, paginasRestantes: totalPaginas - pagina })}</p>`;
    },
    cardVaga(data) {
      const geoData = getGeoData();
      const timeZone = geoData.data != null && geoData.data.timezone ? geoData.data.timezone : "America/Sao_Paulo";
      let dataCadastro = convertDatetimeStringToTimezone(data.dataCadastro, timeZone);
      let dataExpiracao = convertDatetimeStringToTimezone(data.dataExpiracao, timeZone);

      const vagaImpulsionadaHtml = data.impulsionada ? `<ul class="d-flex ps-0 mt-3 mt-lg-0">
                                                          <span class="badge rounded-4 d-inline-block d-md-flex warning-badge-color  fw-bold me-0 me-md-4">
                                                            <div class="d-flex column-gap-1 align-items-center">
                                                                <i class="bi bi-fire py-md-1"></i> 
                                                                <span>${i18next.t('VagaUrgente')}</span>
                                                            </div>
                                                          </span>
                                                        </ul>` : ''

      const vagaEditalInfoHtml = `
                <div class="edital-info my-lg-3">
                    <div class="edital-info-row">
                        <div class="edital-label-group">
                            <i class="bi bi-file-earmark-text-fill"></i>
                            <span class="edital-label">${i18next.t("InfoEditalNumero")}</span>
                        </div>
                        <span class="edital-value">${data.codigoEdital}</span>
                    </div>
                    <div class="edital-info-row">
                        <div class="edital-label-group">
                            <i class="bi bi-calendar2-check-fill"></i>
                            <span class="edital-label">${i18next.t("InfoEditalPublicacao")}</span>
                        </div>
                        <span class="edital-value">${dataCadastro}</span>
                    </div>
                    <div class="edital-info-row">
                        <div class="edital-label-group">
                            <i class="bi bi-calendar2-range-fill"></i>
                            <span class="edital-label">${i18next.t("InfoEditalInscricao")}</span>
                        </div>
                        <span class="edital-value">${dataCadastro} ~ ${dataExpiracao}</span>
                    </div>
                </div>
                ${vagaImpulsionadaHtml}`;

      return `
            <a prefetch href="/${data.url}" class="text-decoration-none">
                <article class="card shadow-sm border-0 mb-3 card-vaga">
                    <div class="card-body">
                        <div class="row gx-0 d-flex justify-content-center">
                            <div class="col-2 col-lg-1">
                                <div class="img-responsiva rounded logo-aside-tamanho">
                                    <img loading=lazy class="" src="${data.logoThumb}" alt="${data.empresa}" title="${data.empresa}">
                                </div>
                            </div>
                            <div class="col-10 col-lg-11 ajuste-padding-col-vaga-info ps-md-0 ps-lg-3 ps-xl-0">
                                <div class="d-flex justify-content-between card-vaga-empresa-data" style="height: 2.2em">
                                    <p class="text-truncate card-vaga-empresa">${data.empresa}</p>
                                    <p class="text-muted text-right me-2 me-md-0 card-vaga-data text-truncate"><small class="texto-data-card">${data.data}</small></p>
                                </div>
                                <p class="fw-bold fs-4 titulo-vaga text-truncate">${data.titulo}</p>
                                <p class="d-none d-lg-flex" style="margin-top: -0.8em"><small class="text-muted">${data.chamada}</small></p>
                                ${vagaEditalInfoHtml}
                            </div>
                        </div>
                    </div>
                </article>
            </a>`;
    },
    skeletonLoadingCardVaga(amount) {
      let html = '';
      for (let i = 0; i < amount; ++i) {
        html += `<div class="card shadow border-0 mb-3 card-loading"><div class="card-body"><div class="row"><div class="col-2 col-lg-1"><div class="rounded card-loading-image"></div></div><div class="col-10 col-lg-11"><div class="d-flex gap-2 justify-content-start justify-content-md-between"><div class="card-loading-bar" style="width: 50%"></div><div class="card-loading-bar" style="width: 50%"></div></div><div class="card-loading-bar"></div><div class="card-loading-bar" style="height: 6em"></div><div class="d-flex gap-5"><div class="card-loading-bar" style="width: 5em"></div><div class="card-loading-bar" style="width: 5em"></div></div></div></div></div></div>`;
      }
      return html;
    },
    alertaNenhumEdital() {
      return `<div class="alert alert-light text-center mt-4">${i18next.t('AlertaNenhumEditalEncontrado')}</div>`;
    }
  },
  // WCAG 4.1.3: a troca da listagem por AJAX nao gera anuncio nenhum sem escrever nesta live region
  anunciarStatus(texto) {
    const regiao = this.props.elementos.regiaoStatus;
    if (regiao) regiao.textContent = texto;
  },
  setLoading(isLoading) {
    this.props.carregando = isLoading;
    const { btnCarregar, btnCarregarContainer } = this.props.elementos;

    if (isLoading) {
      this.anunciarStatus(i18next.t('StatusBuscaCarregando'));
      btnCarregar?.setAttribute('data-status', 'carregando');
      this.props.estadoAbas[this.props.abaAtiva].container.insertAdjacentHTML('beforeend', this.templates.skeletonLoadingCardVaga(3));
      if (btnCarregarContainer) btnCarregarContainer.style.display = 'none';
    } else {
      document.querySelectorAll('.card-loading').forEach(el => el.remove());
    }
  },
  atualizarInformacoes(abaId, editais, totalRegistros) {
    const aba = this.props.estadoAbas[abaId];
    document.querySelector(`#${abaId}-tab .badge`).textContent = totalRegistros;
    const textoAnunciosSpan = document.querySelector(`#${abaId} .ajuste-texto-anuncios-vagas > .fw-bold`);
    const textoContadorMobile = this.props.elementos.contadorMobileContainer.querySelector('.ajuste-texto-anuncios-editais-mobile > .fw-bold')

    if (textoAnunciosSpan) {
      textoAnunciosSpan.textContent = `${totalRegistros} ${i18next.t('TotalAnunciosEditalTexto')}`;
      textoContadorMobile.textContent = `${totalRegistros} ${i18next.t('TotalAnunciosEditalTexto')}`;
    }

    if (editais.length > 0) {
      aba.container.innerHTML = editais.map(vaga => this.templates.cardVaga(vaga)).join('');
    } else {
      aba.container.innerHTML = this.templates.alertaNenhumEdital();
    }
  },
  toggleBotaoCarregarMais() {
    const abaAtiva = this.props.estadoAbas[this.props.abaAtiva];
    const { btnCarregar, btnCarregarContainer } = this.props.elementos;

    if (abaAtiva.pagina < abaAtiva.totalPaginas) {
      if (btnCarregarContainer) btnCarregarContainer.style.display = 'flex';
      if (btnCarregar) btnCarregar.dataset.status = "pronto";
    } else {
      if (btnCarregarContainer) btnCarregarContainer.style.display = 'none';
    }
  },
  construirQueryString: function (ehNovaBusca) {
    const params = new URLSearchParams();
    const aba = this.props.estadoAbas[this.props.abaAtiva];
    const cargo = document.getElementById('cargo').value;
    const localizacao = document.getElementById('localizacao-0').value;

    if (!ehNovaBusca) {
      params.set('status', aba.statusFiltro);
    }

    params.set('pagina', aba.pagina);

    if (cargo) {
      params.set('query', cargo);
    }

    if (localizacao) {
      params.set('localidade', localizacao);
    }

    const empresaID = document.getElementById('hotSiteEmpresaID')?.value;
    const hotSiteUrl = document.getElementById('hotSiteUrl')?.value;

    if (empresaID) {
      params.set('EmpresaID', empresaID);
    }

    if (hotSiteUrl) {
      params.set('HotSiteUrl', hotSiteUrl);
    }

    const unidadeNegocio = document.getElementById('unidadeNegocioFiltro')?.value;

    if (unidadeNegocio) {
      params.set('unidadeNegocio', unidadeNegocio);
    }

    return params.toString();
  },
  buscarDadosAPI: async function (ehNovaBusca = false) {
    if (this.props.carregando) return;


    if (ehNovaBusca) {
      Object.values(this.props.estadoAbas).forEach(a => {
        a.container.innerHTML = '';
        a.pagina = 1;
      });
    }

    this.setLoading(true);

    const queryString = this.construirQueryString(ehNovaBusca);

    try {
      const request = await fetch(`${URL_API}editais/buscar?${queryString}`);
      const response = await request.json();

      this.setLoading(false);

      if (response.sucesso && response.model && response.model.dados) {
        const dados = response.model;
        const abaAtivaId = this.props.abaAtiva;
        const statusApiAbaAtiva = this.statusMap[abaAtivaId];

        if (ehNovaBusca) {
          Object.keys(this.props.estadoAbas).forEach(abaId => {
            const statusApi = this.statusMap[abaId];
            this.props.estadoAbas[abaId].totalPaginas = dados.totalPaginasPorStatus[statusApi] || 1;
            const editaisParaAba = dados.dados[statusApi] || [];
            const totalRegistrosParaAba = dados.totalRegistroPorStatus[statusApi] || 0;
            this.atualizarInformacoes(abaId, editaisParaAba, totalRegistrosParaAba);
          });
        } else {
          const abaAtiva = this.props.estadoAbas[abaAtivaId];
          abaAtiva.totalPaginas = dados.totalPaginasPorStatus[statusApiAbaAtiva] || 1;
          const editaisParaAba = dados.dados[statusApiAbaAtiva] || [];

          let conteudoHtml = abaAtiva.pagina > 1 ? this.templates.textoIndicadorPagina(abaAtiva.pagina, abaAtiva.totalPaginas) : '';
          conteudoHtml += editaisParaAba.map(vaga => this.templates.cardVaga(vaga)).join('');
          abaAtiva.container.insertAdjacentHTML('beforeend', conteudoHtml);
        }
        this.toggleBotaoCarregarMais();

        const totalAbaAtiva = dados.totalRegistroPorStatus?.[statusApiAbaAtiva] || 0;
        this.anunciarStatus(`${totalAbaAtiva} ${i18next.t('TotalAnunciosEditalTexto')}`);
      } else {
        Object.keys(this.props.estadoAbas).forEach(abaId => this.atualizarInformacoes(abaId, [], 0));
        this.anunciarStatus(i18next.t('AlertaNenhumEditalEncontrado'));
      }
    } catch (e) {
      console.error({ catchBuscarDadosAPI: e });
      Object.values(this.props.estadoAbas).forEach(a => a.container.innerHTML = `<div class="alert alert-danger">Erro ao carregar os dados.</div>`);
      this.setLoading(false);
    }
  },
  eventoPushState: async function () {
    let queryString = this.props.filtrosSelecionados
      .map(filtro => `${encodeURIComponent(filtro.nome)}=${encodeURIComponent(filtro.valor)}`)
      .join('&');

    window.history.pushState({}, '', `${location.pathname}?${queryString}`);
    await this.buscarDadosAPI(true);
  },
  atualizarFiltrosSelecionados: async function (novosFiltros) {
    novosFiltros.forEach(filtroAtual => {
      const filtroExistenteIndex = this.props.filtrosSelecionados.findIndex(f => f.nome === filtroAtual.nome);
      if (filtroExistenteIndex !== -1) {
        // Se o valor for vazio, remove o filtro; senão, atualiza.
        if (filtroAtual.valor) {
          this.props.filtrosSelecionados[filtroExistenteIndex] = filtroAtual;
        } else {
          this.props.filtrosSelecionados.splice(filtroExistenteIndex, 1);
        }
      } else if (filtroAtual.valor) {
        this.props.filtrosSelecionados.push(filtroAtual);
      }
    });
    await this.eventoPushState();
  },
  eventoSubmitFormHeaderBuscarEditais: function (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      window.scrollTo(0, 0);

      const inputCargo = e.target.querySelector('input[name="cargo"]').value;
      const inputLocalizacao = e.target.querySelector('input[name="localizacao"]').value;

      await this.atualizarFiltrosSelecionados([
        { nome: 'query', valor: inputCargo },
        { nome: 'localidade', valor: inputLocalizacao }
      ]);
    });
  },
  sincronizarControlesDeAbas: function () {
    const dropdownButton = document.getElementById('dropdown-statusEdital');
    const radioInputs = document.querySelectorAll('#dropdownStatusContainer input[name="statusEditalRadio"]');
    const tabLinks = document.querySelectorAll('#editaisTab a[data-bs-toggle="tab"]');

    const ativarAba = (targetHref) => {
      const tabParaAtivar = document.querySelector(`#editaisTab a[href="${targetHref}"]`);
      if (tabParaAtivar) new bootstrap.Tab(tabParaAtivar).show();
    }

    radioInputs.forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          ativarAba(radio.value);
          if (dropdownButton) dropdownButton.textContent = radio.getAttribute('data-text');
        }
      });
    });

    tabLinks.forEach(tab => {
      tab.addEventListener('shown.bs.tab', (event) => {
        this.props.abaAtiva = event.target.hash.replace('#', '');
        const radioCorrespondente = document.querySelector(`input[name="statusEditalRadio"][value="#${this.props.abaAtiva}"]`);
        if (radioCorrespondente) {
          radioCorrespondente.checked = true;
          if (dropdownButton) dropdownButton.textContent = radioCorrespondente.getAttribute('data-text');
        }
        this.toggleBotaoCarregarMais();
      });
    });
  },
  trocarSetaDropdown(elemento) {
    if (elemento.closest('.dropdown') != undefined) {
      elemento.closest('.dropdown').dispatchEvent(new Event('hide.bs.dropdown'));
      elemento.closest('.dropdown-menu').classList.toggle('show');
    }
  },
  init: function () {
    autocompleteBuscaRecenteLocalizacao(null, '#localizacao-0');
    autocompleteBuscaRecenteCargo(document.querySelector('#pesquisa-cargo-hotsite'), '#cargo');

    const parametrosUrl = new URLSearchParams(location.search);
    const unidadeNegocioUrl = document.getElementById('unidadeNegocioFiltro')?.value;


    const temParametrosNaUrl = [...parametrosUrl.keys()].some(chave => chave !== 'unidadeNegocio');

    document.querySelectorAll('.formHeaderBuscarEditais').forEach(el => this.eventoSubmitFormHeaderBuscarEditais(el));

    const urlParams = obterQueryString();
    if (urlParams.query) {
      document.getElementById('cargo').value = urlParams.query;
      this.props.filtrosSelecionados.push({ nome: 'query', valor: urlParams.query });
    }
    if (urlParams.localidade) {
      document.getElementById('localizacao-0').value = urlParams.localidade;
      this.props.filtrosSelecionados.push({ nome: 'localidade', valor: urlParams.localidade });
    }


    if (unidadeNegocioUrl) {
      this.props.filtrosSelecionados.push({ nome: 'unidadeNegocio', valor: unidadeNegocioUrl });
    }

    if (temParametrosNaUrl) {
      this.buscarDadosAPI(true);
    }

    window.addEventListener('popstate', async () => {
      const params = new URLSearchParams(window.location.search);
      document.getElementById('cargo').value = params.get('query') || '';
      document.getElementById('localizacao-0').value = params.get('localidade') || '';
      await this.buscarDadosAPI(true);
    });

    Object.keys(this.props.estadoAbas).forEach(abaId => {
      const container = document.getElementById(abaId);
      if (container) {
        this.props.estadoAbas[abaId].totalPaginas = parseInt(container.getAttribute('data-total-paginas'), 10) || 1;
      }
    });

    if (this.props.elementos.btnCarregar) {
      this.props.observerCarregarMaisVagas = new IntersectionObserver((entries) => {
        const botao = entries[0];
        if (botao.isIntersecting && botao.target.dataset.status === "pronto") {
          botao.target.click();
        }
      }, { threshold: 1 });
      this.props.observerCarregarMaisVagas.observe(this.props.elementos.btnCarregar);

      this.props.elementos.btnCarregar.addEventListener('click', (e) => {
        e.preventDefault();
        const aba = this.props.estadoAbas[this.props.abaAtiva];
        if (aba.pagina < aba.totalPaginas && !this.props.carregando) {
          aba.pagina++;
          this.buscarDadosAPI(false);
        }
      });
    }

    document.querySelectorAll('.btn-fechar-dropdown').forEach(el => el.addEventListener('click', (e) => {
      this.trocarSetaDropdown(e.target);
    }));


    this.toggleBotaoCarregarMais();
    this.sincronizarControlesDeAbas();
  }
};

(async () => await editais.init())();